import Icons from "Pages/Global/Icons";

const GlobalRoutes = {
  Icons: {
    path: "/icons",
    element: Icons,
    noPadding: true,
    noHeader: true,
  },
};

export default GlobalRoutes;
